<template>
<div id="news-detail">
  <div style="font-size: 22px;font-weight: bold;color: #000000;">{{newsTitle}}</div>
  <div style='font-size: 15px;color: #bebebe;line-height: 25px;'>发布时间：{{newsCteateTime}}</div>
  <div style='font-size: 15px;color: #bebebe;line-height: 25px;' v-on:click="linkGoClick">来源：{{newsFrom}}</div>
  <hr style='height:1px;border:none;border-top:solid 1px #eeeeee;margin:20px 0;' />
  <p class="content" style="font-size: 18px;line-height: 28px;" v-html="htmlText"></p>
  <div id="news-ads">
    <div class="ads-img"></div>
    <div class="ads-title">中消在线，消防一站式服务平台</div>
    <div class="ads-click" v-on:click="linkGoClick2">下载APP</div>
  </div>
</div>
</template>

<script>
import wxShare from '../../wx/weixin.js'
// 引入
// import { Indicator} from 'mint-ui'

export default{
  data () {
    return {
      newsID: '0',
      newsTitle: '',
      newsCteateTime: '',
      newsSubTitle: '',
      newsFrom: '',
      newsFromLink: '',
      htmlText: ''
    }
  },
  methods: {
    loadNewsData: function () {
      this.newsID = this.$route.query.newsID

      var _this = this
      this.utils.GET(this.accountUrl + '/jpressContent/detail?articleId=' + this.newsID,
        function (data) {
          _this.dataHandel(data.data)
        })
    },
    dataHandel: function (result) {
      this.htmlText = result.text
      this.newsTitle = result.title
      this.newsCteateTime = result.created
      this.newsSubTitle = result.meta_description
      this.newsFrom = '中消在线'
      this.newsFromLink = ''
      let froms = result.tails.metaData

      for (var i = 0; i < froms.length; i++) {
        var dict = froms[i]
        if (dict.meta_key === '_from') {
          if (dict.meta_value != null) {
            this.newsFrom = dict.meta_value
          }
        }
        if (dict.meta_key === '_link') {
          this.newsFromLink = dict.meta_value
        }
      }
      console.log(this.newsFrom)
      console.log(this.newsFromLink)

      var _this = this

      // 图片处理
      setTimeout(() => {
        var maxWidth = document.body.clientWidth - 30
        if (maxWidth) {
          var myimg, oldwidth, oldheight
          var imgs = document.querySelectorAll('img')
          for (var i = 0; i < imgs.length; i++) {
            myimg = document.images[i]
            oldwidth = myimg.width
            oldheight = myimg.height
            myimg.width = maxWidth
            myimg.height = maxWidth * oldheight / oldwidth
            myimg.margin = '10px 0'
          }
        }

        // tabbar 调整高度
        if (_this.utils.isIphoneX()) {
          document.getElementById('news-ads').style.height = '70px'
        }
      }, 50)
      // http://www.zxzx119.com/static/spa/img/no_pic.20c23a8.png
      // 微信 分享
      var imgUrl = 'http://www.zxzx119.com/static/spa/img/no_pic.20c23a8.png'
      if (result.thumbnail != null && result.thumbnail.length > 0) {
        imgUrl = this.utils.ResourceUrl + result.thumbnail
      }
      wxShare.wxRegister(this.newsTitle, this.newsSubTitle, imgUrl)

      let isApp = this.$route.query.isApp
      if (parseInt(isApp) !== 1) { // H5 统计
        // 统计
        this.utils.listenEvent(1, this.newsID, window.location.href, this.newsTitle)
      }
    },
    linkGoClick: function (e) {
      if (this.newsFromLink != null && this.newsFromLink.length > 0) {
        window.location.href = this.newsFromLink
      }
    },
    linkGoClick2: function () {
      // 统计
      this.utils.listenEvent(3, this.newsID, window.location.href, this.newsTitle)

      this.$router.push({path: 'web-guide', query: {}})
    }
  },
  mounted () {
    console.log('============================')
    // 获取新闻详情数据
    this.loadNewsData()
  },
  watch: { // 监测
    $router () {
    }
  }
}
</script>

<style scoped="scoped">
*{
  -webkit-touch-callout:none;
  -webkit-user-select:none;
  -khtml-user-select:none;
  -moz-user-select:none;
  -ms-user-select:none;
  user-select:none;
}
body {
    padding-top: constant(safe-area-inset-top);
    padding-left: constant(safe-area-inset-left);
    padding-right: constant(safe-area-inset-right);
    padding-bottom: constant(safe-area-inset-bottom);
}
#news-detail{
  margin: 0px 15px 100px 15px;
}
img {
  width: 100%;
  height: auto;
}
#news-ads{
  position: fixed;
  bottom: 0;
  left: 0px;
  width: 100%;
  height: 60px;
      background: rgba(0, 0, 0, 0.7);
}
#news-ads .ads-img{
  position: absolute;
  top: 12px;
  left: 10px;
  width: 40px;
  height: 40px;
  background-image: url(../../assets/web_logo.png);
  background-size: cover;
  background-position: center center;

}
#news-ads .ads-title{
  position: absolute;
  top: 10px;
  left: 58px;
  width: 250px;
  height: 40px;
  line-height: 40px;
  color: #FFFFFF;
  font-size: 15px;
}
#news-ads .ads-click{
  position: absolute;
  float: right;
  top: 15px;
  right: 10px;
  width: 70px;
  height: 30px;
  line-height: 30px;
  background-color: #c41335;
  border-radius: 15px;
  color: #FFFFFF;
  font-size: 13px;
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/view/app/news-detail.vue